import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import srOnly from '@helpers/srOnly';
import { paragraphSmall } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.button `
  display: inline-flex;
  align-items: center;
  border: var(--borderWidth, 0) solid var(--colorBorder, var(--colorBg));
  background: var(--colorBg);
  background-image: linear-gradient(to right, var(--colorBgActive), var(--colorBgActive));
  background-repeat: no-repeat;
  background-size: 0% 100%;
  color: var(--colorFg);
  min-height: 52px;
  padding: 12px 26px;
  text-decoration: none;
  ${transition('background-size, border-color, opacity')};
  user-select: none;
  width: auto;

  &[data-fill='right'] {
    background-position: left center;
  }

  &[data-fill='left'] {
    background-position: right center;
  }

  span& {
    button.focus-ring &,
    a.focus-ring & {
      outline: auto;
      outline-offset: -5px;
      outline-width: 2px;
      outline-style: solid;
    }

    button.focus-ring,
    a.focus-ring,
    button:hover &,
    a:hover & {
      border-color: var(--colorBorderActive, var(--colorBgActive));
      color: var(--colorFgActive);
      background-size: 100% 100%;
    }
  }

  &:not(span) {
    cursor: pointer;

    &:focus {
      outline: none;
    }

    &.focus-ring {
      outline: auto;
      outline-offset: -5px;
      outline-width: 2px;
      outline-style: solid;
    }

    &.focus-ring,
    &:hover {
      border-color: var(--colorBorderActive, var(--colorBgActive));
      color: var(--colorFgActive);
      background-size: 100% 100%;
    }
  }

  &[data-type='default'] {
    --colorBg: ${brand.green};
    --colorFg: ${brand.white};
    --colorBgActive: ${brand.black};
    --colorFgActive: ${brand.white};
  }

  &[data-type='inverted'] {
    --colorBg: ${brand.white};
    --colorFg: ${brand.black};
    --colorBgActive: ${brand.black};
    --colorFgActive: ${brand.white};
  }

  &[data-type='outline'] {
    --borderWidth: 2px;
    --colorBg: ${brand.white};
    --colorFg: ${brand.green};
    --colorBorder: ${brand.green};
    --colorBgActive: ${brand.green};
    --colorFgActive: ${brand.white};
    --colorBorderActive: ${brand.green};
  }

  &[data-icon-only='true'] {
    height: 52px;
    justify-content: center;
    padding: 0;
    width: 52px;
  }

  /* Increase specificity to override :not(span) style */
  &:disabled:disabled:disabled {
    background-size: 0% 100%;
    opacity: 0.5;
    pointer-events: none;
  }

  @media ${until(Device.TabletLarge)} {
    min-height: 45px;
    padding: 6px 12px;

    &[data-icon-only='true'] {
      height: 45px;
      width: 45px;
    }
  }

  @media print {
    display: none !important;
  }
`;
const Text = styled.span `
  ${transition('color')};
  ${paragraphSmall};
  ${fonts.brandonGrotesque.bold};

  color: currentColor;
  line-height: 1.25;
  margin: 0;
  text-decoration: none;
  text-transform: uppercase;

  [data-icon-only='true'] & {
    ${srOnly};
  }
`;
const IconWrapper = styled.div `
  display: block;
  color: currentColor;
  height: 17px;
  margin: 0;
  padding: 0;
  ${transition('color')};
  width: 37px;

  [data-icon-position='left'] & {
    margin-right: auto;
    order: -1;
    padding-right: 20px;
  }

  [data-icon-position='right'] & {
    margin-left: auto;
    order: 1;
    padding-left: 20px;
  }

  [data-icon-only='true'] & {
    color: currentColor;
    height: 17px;
    margin: 0;
    padding: 0;
    width: 17px;
  }
`;
const ButtonStyles = {
    Container,
    IconWrapper,
    Text,
};
export default ButtonStyles;
